import moment from 'moment';
import _ from 'lodash';
import formatCurrency from 'format-currency';

class PayrollExpenseMappingController {
  constructor($rootScope, $uibModal, $state, $http,toastr) {
    "ngInject";
    this.state = $state;
    this.$http = $http;
    this.$rootScope = $rootScope;

    this.contracts = [];
    this.qbContracts = [];
    this.toastr = toastr;

    let self = this;

    this.$http.get(self.$rootScope.apiHost+"/api/integrations/qb/payrollexpensemapping", {withCredentials: true}).then(function (success) {
      self.expenseMappings = success.data;
    });

    this.$http.get(self.$rootScope.apiHost+"/api/integrations/qb/accounts?type=All", {withCredentials: true}).then(function (success) {
      self.qbExpenseAccounts = success.data;
    });




  }

  getQuickbooksAccountName(qbId) {
    let name = undefined;
    if(this.qbExpenseAccounts) {
      this.qbExpenseAccounts.forEach(function (account) {
        if(account.id === qbId) {
          name = account.acctNum + " - " + account.fullyQualifiedName;
        }
      })
    }
    return name;
  }

  mapQbAccount(mapping) {
    mapping.quickbooksAccount = mapping.account.id;
    console.log(mapping);

    this.$http.post(this.$rootScope.apiHost+"/api/integrations/qb/payrollexpensemapping/"+mapping.id, mapping, {withCredentials: true}).then(function (success) {

    });

  }

  getContractName(id) {
    let x = _.find(this.qbContracts, { 'id': id});
    if(x) {
      return x.displayName;
    }
  }

  updateContractDetails(id, parameter, value) {
    let self = this;
    let obj = {};
    obj[parameter] = value;

    this.$http.patch(this.$rootScope.apiHost+"/api/admin/contracts/"+id, obj, {withCredentials: true}).then(function (success) {
      self.loadContracts();
      self.toastr.success("Successfully Paired Contract With Quickbooks!", "SUCCESS");
    }, function (failure) {
      self.toastr.error("Could Not Pair Contract With Quickbooks.", "ERROR");
    });
  }


  syncContractsWithQuickbooks() {
    let self = this;
    this.$http.get(self.$rootScope.apiHost+"/api/integrations/qb/contracts/sync", {withCredentials: true}).then(function (success) {
      self.loadContracts();
      self.loadQbContracts();
    });
  }


  loadContracts() {
    let self = this;
    this.$http.get(self.$rootScope.apiHost+"/api/admin/contracts", {withCredentials: true}).then(function (success) {
      self.contracts = success.data;
    });
  }

  loadQbContracts() {
    let self = this;
    this.$http.get(self.$rootScope.apiHost+"/api/integrations/qb/contracts", {withCredentials: true}).then(function (success) {
      self.qbContracts = success.data;
    });
  }

}

export default PayrollExpenseMappingController;



// WEBPACK FOOTER //
// ./client/pages/admin/integrations/quickbooks/capabilities/payroll-expense-mapping/payroll-expense-mapping.controller.js